import React from "react";
import ClearPaused from "../common/ClearPause";
import { LogRenderContext } from "../LogRenderer";
import { getTargetGroupDetails } from "../utils";

const TargetGroupClearPaused = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, updatedBy, updatedAt } = getTargetGroupDetails(log);
  return <ClearPaused name={name} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default TargetGroupClearPaused;
